<template>
  <MainLayout>
    <b-overlay :show="showOverlay">
      <!--Table-->
      <b-paginated-table
          class="mb-0"
          stacked="md"
          :items="items"
          :fields="fields"
          primary-key="id"
          :busy="isBusy"
          caption-top
          :current-page="currentPage"
          :per-page="perPage">
        <template v-slot:table-busy>
          <div class="text-center text-primary mt-5 mb-3">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Chargement...</strong>
          </div>
        </template>
        <template v-slot:top-row v-if="canCreateText">
          <td colspan="100%">
            <b-button block variant="outline-primary" @click="open">
              <b-icon-plus class="mr-2"/>
              <span>Nouveau Texte</span>
            </b-button>
          </td>
        </template>
        <template v-slot:cell(title)="{value, item}">
          <div :class="titleClass(item)" @click="editTitle(item)">
            {{ value }}
          </div>
        </template>
        <template v-slot:cell(status)="{item:{id,fini,corrige}}">
          <texte-status :key="id" :text="id" :fini="fini" :corrige="corrige"></texte-status>
        </template>
        <template v-slot:cell(Actions)="{item}">
          <b-button variant="primary" @click="details(item)" size="sm" class="mr-1">Voir</b-button>
          <b-button variant="outline-danger" @click="confirmDiscard(item.id)" v-if="canDiscard(item.id)" size="sm">
            Supprimer
          </b-button>
        </template>
      </b-paginated-table>
      <!--Modal-->
      <b-modal id="title" title="Nouveau Texte" @ok="create">
        <b-form-input
            id="title"
            autofocus
            v-model="modal.input"
            placeholder="Titre"
            :state="titleState"
            @keypress.enter="create();$bvModal.hide('title')"/>
        <b-form-invalid-feedback id="title">
          Le titre est trop long
        </b-form-invalid-feedback>
      </b-modal>
      <b-modal id="edit-title" title="Nouveau Titre" @ok="changeTitle()">
        <b-form-input
            id="edit-title-input"
            autofocus
            v-model="edit.input"
            placeholder="Titre"
            :state="titleState"
            @keypress.enter="changeTitle();$bvModal.hide('edit-title')"/>
        <b-form-invalid-feedback id="title">
          Le titre est trop long
        </b-form-invalid-feedback>
      </b-modal>
      <confirmation-box
          id="deleteTexte"
          cancel-msg="Non, ne pas supprimer"
          @ok="discard"
      />
    </b-overlay>
  </MainLayout>
</template>

<script>
import ConfirmationBox from "@/components/confirmationBox";
import {Auth, LocalID, Textes} from "@/js/caller";
import {History} from "@/js/history";
import TexteStatus from "@/components/status/TexteStatus";
import {DataFormat} from "@/js/utils";
import BPaginatedTable from "../../components/BPaginatedTable";

export default {
  name: "TextesList",
  components: {BPaginatedTable, TexteStatus, ConfirmationBox},
  data() {
    const fields = [
      {
        key: 'created_at',
        label: 'Date',
        sortable: true,
        formatter: (value) => new Date(value).toLocaleDateString()
      },
      {
        key: 'title',
        label: 'Titre',
        filterable: true,
        formatter: (value, key, item) => value ? value : item.id
      },
      {
        key: "status",
        sortable: true,
      },
      'Actions'
    ]
    if (Auth.IsTeacher())
      fields.splice(1, 0, {
        key: 'prenom',
        label: 'Élève',
        sortable: true,
        sortByFormatted: true,
        formatter: (value, key, item) => value ? value : item.mail
      })
    return {
      items: [],
      fields,
      isBusy: true,
      showOverlay: false,
      currentPage: 1,
      perPage: 20,
      modal: {
        input: "",
      },
      edit: {
        item: null,
        input: ""
      },
      //
      registeredIds: [],
    }
  },
  computed: {
    rows() {
      return this.items.length
    },
    titleState() {
      const {input} = this.modal
      return input === "" ? null : input.length <= 128;
    },
    canCreateText() {
      const token = Auth.Token()
      return token.meta?.acces_ecole || token.user.acces_ecole;
    }
  },
  created() {
    this.options = History.Persistence.Get() || this.options;
    this.getList().then(() => {
      this.isBusy = false
    });
    const id = Auth.Register(Auth.Events.Login, () => {
      this.canCreateText = !!Auth.Token().meta?.acces_ecole;
    })
    this.registeredIds.push(id)
  },
  destroyed() {
    this.registeredIds.forEach(id => {
      Auth.Unregister(id);
    })
  },
  methods: {
    getList() {
      return Textes.GetList()
          .then(data => {
            this.items = data.map(i => {
              return {...i, status: DataFormat.Textes.GetStatus()(i.text, i.fini, i.corrige)}
            });
          })
    },
    details(item) {
      this.$router.push(`/textes/${item.id}`)
    },
    open() {
      if (this.canCreateText) this.$bvModal.show("title")
    },
    create() {
      const {modal: {input: title}, titleState} = this;
      if (!titleState) return;
      const item = Textes.createLocal(title);
      //if (item) this.items.unshift(item);
      if (item) this.details(item);
      //this.modal.input = "";
    },
    canDiscard(id) {
      return LocalID.isLocalID(id)
    },
    confirmDiscard(id) {
      //this.showOverlay   = true;
      this.$bvModal.show("deleteTexte")
      this.dataToDiscard = id
    },
    discard() {
      this.showOverlay = false
      const id = this.dataToDiscard;
      Textes.discardLocal(id)
      this.items = this.items.filter(item => item.id !== id)
    },
    //table
    titleClass({id}) {
      return "title" + (LocalID.isLocalID(id) ? " local" : "");
    },
    editTitle(item) {
      if (!LocalID.isLocalID(item.id)) return
      this.edit.item = item
      this.edit.input = item.title
      this.$bvModal.show("edit-title")
    },
    changeTitle() {
      const {item, input} = this.edit;
      item.title = input;
      Textes.SaveLocal(item);
      this.edit = {item: null, input: ""}
    },
  }
}
</script>

<style scoped>

</style>